import RemoveIcon from 'imagesUwKluis/svg/close.svg';
import { bool, func, number, string, shape } from 'prop-types';
import Card from '../../shared/Card';
import Date from '../../shared/Date';
import Header from '../../shared/Header';
import Input from '../../shared/Input';
import {Box, Cluster, Stack} from '../../shared/layouts';
import Select from '../../shared/Select';
import FormStack from '../../shared/layouts/FormStack';
import i18n from "../../../i18n";
import {useTranslation} from "react-i18next";
import RadioButton from "../../shared/RadioButton";
import useIconLibrary from "../../../hooks/useIconLibrary";

const getCoverageTypes = () => [
  { value: 'constant', label: i18n.t('Gelijkblijvend') },
  { value: 'linear_decrease', label: i18n.t('Lineair dalend') },
  { value: 'annuity_decrease', label: i18n.t('Annuitair dalend') },
];

const getIsSmokerOptions = () => [
  { value: false, label: i18n.t('Nee') },
  { value: true, label: i18n.t('Ja') },
];

const CoverageSection = ({
  indexCoverage,
  indexInsurance,
  removeCoverage,
  setCoverage,
  is_smoker,
  covered,
  coverage,
  removable,
  start_date,
  end_date,
  coverage_type,
  errors,
  canEditOrv,
}) => {
  const { t } = useTranslation();

  const readOnly = !canEditOrv;
  const coverageTypes = getCoverageTypes();
  const { CurrencyIcon } = useIconLibrary();

  const FormFiller = (props) => !readOnly && <Box {...props} />;

  return (
    <Card>
      <Stack space="m" width="100%">
        <Header
          title={
            <Cluster hGap="l">
              <span>Verzekerde {indexCoverage + 1}</span>
              {removable && canEditOrv && (
                <RemoveIcon
                  css={(theme) => ({
                    fill: theme?.colors?.alert || 'red',
                    cursor: 'pointer',
                    margin: '4px',
                    width: '32px',
                    height: '32px',
                  })}
                  onClick={removeCoverage}
                />
              )}
            </Cluster>
          }
          icon={<CurrencyIcon height="2rem" width="2rem" />}
          variant="section"
        />
        <FormStack space="m" readOnly={readOnly}>
          <Input
            label={t("Verzekerde")}
            name="covered"
            onChange={setCoverage}
            value={covered}
            errors={
              errors[`${indexInsurance}.coverages.${indexCoverage}.covered`]
            }
            readOnly={readOnly}
          />
          <FormFiller />
          {/* Row */}
          <RadioButton
            label={t("Rookt")}
            name={`is_smoker_${indexInsurance}${indexCoverage}`}
            direction={'row'}
            value={is_smoker}
            options={getIsSmokerOptions()}
            onChange={(value) =>
              setCoverage({ target: { name: 'is_smoker', value } })
            }
            errors={
              errors[`${indexInsurance}.coverages.${indexCoverage}.is_smoker`]
            }
            readOnly={readOnly}
          />
          <FormFiller />
          {/* Row */}
          <Input
            label={t("Dekking")}
            isCurrency
            name="coverage"
            onChange={setCoverage}
            value={coverage}
            errors={
              errors[`${indexInsurance}.coverages.${indexCoverage}.coverage`]
            }
            readOnly={readOnly}
          />
          <Select
            label={t("Type dekking")}
            name="coverage_type"
            onChange={setCoverage}
            options={coverageTypes}
            value={coverage_type}
            errors={
              errors[
                `${indexInsurance}.coverages.${indexCoverage}.coverage_type`
              ]
            }
            readOnly={readOnly}
          />
          {/* Row */}
          <Date
            label={t("Ingangsdatum")}
            name="start_date"
            onChange={setCoverage}
            value={start_date}
            errors={
              errors[`${indexInsurance}.coverages.${indexCoverage}.start_date`]
            }
            readOnly={readOnly}
          />
          <Date
            label={t("Einddatum")}
            name="end_date"
            onChange={setCoverage}
            value={end_date}
            errors={
              errors[`${indexInsurance}.coverages.${indexCoverage}.end_date`]
            }
            readOnly={readOnly}
          />
        </FormStack>
      </Stack>
    </Card>
  );
};

CoverageSection.propTypes = {
  indexCoverage: number.isRequired,
  indexInsurance: number,
  removeCoverage: func,
  setCoverage: func,
  covered: string,
  coverage: number,
  removable: bool,
  start_date: string,
  end_date: string,
  errors: shape({}),
  canEditOrv: bool,
};

CoverageSection.defaultProps = {
  removeCoverage: () => {},
  setCoverage: () => {},
  covered: '',
  coverage: null,
  removable: false,
  errors: {},
  indexInsurance: 0,
  canEditOrv: false,
};

export default CoverageSection;
